import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const RICont = styled.div((props) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const RIContDetail = styled.div((props) => ({
  display: 'flex',
  marginTop: `${props.sub ? '0' : '1rem'}`,
  flexDirection: 'column',

  '&>div:first-child': {
    marginLeft: 0,
    marginTop: '0px',
    flex: 1
  },

  '&>div': {
    marginLeft: '0px',
    marginTop: '1rem',
    flex: 1
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    '&>div': {
      marginLeft: '1rem',
      marginTop: '0px',
      flex: 1
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    '&>div': {
      marginLeft: '1rem',
      marginTop: '0px',
      flex: 1
    },
  },
}))